var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-1e0a7a8e-0743-46f8-8a8a-92d8f120d28c",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 25.03 25.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-adbb236c-00f0-4901-aaa7-cdbd3795106a{fill:none;stroke:url(#uuid-f3cc32e7-d47a-4966-869a-388b79a1b3e9);stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-f3cc32e7-d47a-4966-869a-388b79a1b3e9",
    x1: 3.67,
    y1: 3.67,
    x2: 21.36,
    y2: 21.36,
    gradientTransform: "translate(-5.18 12.51) rotate(-45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4dfcff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#a040ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d640ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-19aafa3e-e98f-422d-ba34-7dd8e24e1279"
  }, /*#__PURE__*/React.createElement("path", {
    className: "uuid-adbb236c-00f0-4901-aaa7-cdbd3795106a",
    d: "m2,23.03L23.03,2m-21.03,0l21.03,21.03"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.6f1089bd9f5eb2f3d81dc12c0188c431.svg";
export { ForwardRef as ReactComponent };